/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	__webpack_require__(2);
	__webpack_require__(3);
	__webpack_require__(4);
	__webpack_require__(5);
	module.exports = __webpack_require__(6);


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	$(function () { 
	    if(window.location.pathname == "/about/"){
	        var filterID;
	        var allStaff = document.querySelectorAll('.about-staff li');
	        var otherTeams;
	        //all filter clicks
	        var filter_anchor = document.querySelectorAll(".filter_anchor");

	        // loop through all filter clicks
	        for(var i=0; i<filter_anchor.length; i++){
	          
	            
	            //onclick
	            filter_anchor[i].addEventListener("click", function(e){
	                e.preventDefault();

	                //init remove all active state
	                $('.about-teams-subnav li').removeClass("active_filter");
	                //add active state
	                this.parentElement.parentElement.classList.add("active_filter");

	                //console.log("filter click");
	                //console.log(this.id)
	                filterID = this.id;
	                //console.log(document.querySelectorAll('li:not([data-team='+filterID+'])'));
	                otherTeams = document.querySelectorAll('.about-staff li:not([data-team='+filterID+'])');

	                 //clear all hidden team member first
	                 for(var j = 0; j < allStaff.length; j++){
	                    allStaff[j].style.display = 'block';
	                 }


	                //hide other teams
	                for(var k = 0; k < otherTeams.length; k++){
	                    otherTeams[k].style.display = 'none';
	                }
	                // document.querySelectorAll('li[data-team='+filterID+']').style.display = 'none';

	            })
	        }
	    }
	});

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	/*!
	 * jQuery throttle / debounce - v1.1 - 3/7/2010
	 * http://benalman.com/projects/jquery-throttle-debounce-plugin/
	 * 
	 * Copyright (c) 2010 "Cowboy" Ben Alman
	 * Dual licensed under the MIT and GPL licenses.
	 * http://benalman.com/about/license/
	 */

	// Script: jQuery throttle / debounce: Sometimes, less is more!
	//
	// *Version: 1.1, Last updated: 3/7/2010*
	// 
	// Project Home - http://benalman.com/projects/jquery-throttle-debounce-plugin/
	// GitHub       - http://github.com/cowboy/jquery-throttle-debounce/
	// Source       - http://github.com/cowboy/jquery-throttle-debounce/raw/master/jquery.ba-throttle-debounce.js
	// (Minified)   - http://github.com/cowboy/jquery-throttle-debounce/raw/master/jquery.ba-throttle-debounce.min.js (0.7kb)
	// 
	// About: License
	// 
	// Copyright (c) 2010 "Cowboy" Ben Alman,
	// Dual licensed under the MIT and GPL licenses.
	// http://benalman.com/about/license/
	// 
	// About: Examples
	// 
	// These working examples, complete with fully commented code, illustrate a few
	// ways in which this plugin can be used.
	// 
	// Throttle - http://benalman.com/code/projects/jquery-throttle-debounce/examples/throttle/
	// Debounce - http://benalman.com/code/projects/jquery-throttle-debounce/examples/debounce/
	// 
	// About: Support and Testing
	// 
	// Information about what version or versions of jQuery this plugin has been
	// tested with, what browsers it has been tested in, and where the unit tests
	// reside (so you can test it yourself).
	// 
	// jQuery Versions - none, 1.3.2, 1.4.2
	// Browsers Tested - Internet Explorer 6-8, Firefox 2-3.6, Safari 3-4, Chrome 4-5, Opera 9.6-10.1.
	// Unit Tests      - http://benalman.com/code/projects/jquery-throttle-debounce/unit/
	// 
	// About: Release History
	// 
	// 1.1 - (3/7/2010) Fixed a bug in <jQuery.throttle> where trailing callbacks
	//       executed later than they should. Reworked a fair amount of internal
	//       logic as well.
	// 1.0 - (3/6/2010) Initial release as a stand-alone project. Migrated over
	//       from jquery-misc repo v0.4 to jquery-throttle repo v1.0, added the
	//       no_trailing throttle parameter and debounce functionality.
	// 
	// Topic: Note for non-jQuery users
	// 
	// jQuery isn't actually required for this plugin, because nothing internal
	// uses any jQuery methods or properties. jQuery is just used as a namespace
	// under which these methods can exist.
	// 
	// Since jQuery isn't actually required for this plugin, if jQuery doesn't exist
	// when this plugin is loaded, the method described below will be created in
	// the `Cowboy` namespace. Usage will be exactly the same, but instead of
	// $.method() or jQuery.method(), you'll need to use Cowboy.method().

	(function(window,undefined){
	  '$:nomunge'; // Used by YUI compressor.
	  
	  // Since jQuery really isn't required for this plugin, use `jQuery` as the
	  // namespace only if it already exists, otherwise use the `Cowboy` namespace,
	  // creating it if necessary.
	  var $ = window.jQuery || window.Cowboy || ( window.Cowboy = {} ),
	    
	    // Internal method reference.
	    jq_throttle;
	  
	  // Method: jQuery.throttle
	  // 
	  // Throttle execution of a function. Especially useful for rate limiting
	  // execution of handlers on events like resize and scroll. If you want to
	  // rate-limit execution of a function to a single time, see the
	  // <jQuery.debounce> method.
	  // 
	  // In this visualization, | is a throttled-function call and X is the actual
	  // callback execution:
	  // 
	  // > Throttled with `no_trailing` specified as false or unspecified:
	  // > ||||||||||||||||||||||||| (pause) |||||||||||||||||||||||||
	  // > X    X    X    X    X    X        X    X    X    X    X    X
	  // > 
	  // > Throttled with `no_trailing` specified as true:
	  // > ||||||||||||||||||||||||| (pause) |||||||||||||||||||||||||
	  // > X    X    X    X    X             X    X    X    X    X
	  // 
	  // Usage:
	  // 
	  // > var throttled = jQuery.throttle( delay, [ no_trailing, ] callback );
	  // > 
	  // > jQuery('selector').bind( 'someevent', throttled );
	  // > jQuery('selector').unbind( 'someevent', throttled );
	  // 
	  // This also works in jQuery 1.4+:
	  // 
	  // > jQuery('selector').bind( 'someevent', jQuery.throttle( delay, [ no_trailing, ] callback ) );
	  // > jQuery('selector').unbind( 'someevent', callback );
	  // 
	  // Arguments:
	  // 
	  //  delay - (Number) A zero-or-greater delay in milliseconds. For event
	  //    callbacks, values around 100 or 250 (or even higher) are most useful.
	  //  no_trailing - (Boolean) Optional, defaults to false. If no_trailing is
	  //    true, callback will only execute every `delay` milliseconds while the
	  //    throttled-function is being called. If no_trailing is false or
	  //    unspecified, callback will be executed one final time after the last
	  //    throttled-function call. (After the throttled-function has not been
	  //    called for `delay` milliseconds, the internal counter is reset)
	  //  callback - (Function) A function to be executed after delay milliseconds.
	  //    The `this` context and all arguments are passed through, as-is, to
	  //    `callback` when the throttled-function is executed.
	  // 
	  // Returns:
	  // 
	  //  (Function) A new, throttled, function.
	  
	  $.throttle = jq_throttle = function( delay, no_trailing, callback, debounce_mode ) {
	    // After wrapper has stopped being called, this timeout ensures that
	    // `callback` is executed at the proper times in `throttle` and `end`
	    // debounce modes.
	    var timeout_id,
	      
	      // Keep track of the last time `callback` was executed.
	      last_exec = 0;
	    
	    // `no_trailing` defaults to falsy.
	    if ( typeof no_trailing !== 'boolean' ) {
	      debounce_mode = callback;
	      callback = no_trailing;
	      no_trailing = undefined;
	    }
	    
	    // The `wrapper` function encapsulates all of the throttling / debouncing
	    // functionality and when executed will limit the rate at which `callback`
	    // is executed.
	    function wrapper() {
	      var that = this,
	        elapsed = +new Date() - last_exec,
	        args = arguments;
	      
	      // Execute `callback` and update the `last_exec` timestamp.
	      function exec() {
	        last_exec = +new Date();
	        callback.apply( that, args );
	      };
	      
	      // If `debounce_mode` is true (at_begin) this is used to clear the flag
	      // to allow future `callback` executions.
	      function clear() {
	        timeout_id = undefined;
	      };
	      
	      if ( debounce_mode && !timeout_id ) {
	        // Since `wrapper` is being called for the first time and
	        // `debounce_mode` is true (at_begin), execute `callback`.
	        exec();
	      }
	      
	      // Clear any existing timeout.
	      timeout_id && clearTimeout( timeout_id );
	      
	      if ( debounce_mode === undefined && elapsed > delay ) {
	        // In throttle mode, if `delay` time has been exceeded, execute
	        // `callback`.
	        exec();
	        
	      } else if ( no_trailing !== true ) {
	        // In trailing throttle mode, since `delay` time has not been
	        // exceeded, schedule `callback` to execute `delay` ms after most
	        // recent execution.
	        // 
	        // If `debounce_mode` is true (at_begin), schedule `clear` to execute
	        // after `delay` ms.
	        // 
	        // If `debounce_mode` is false (at end), schedule `callback` to
	        // execute after `delay` ms.
	        timeout_id = setTimeout( debounce_mode ? clear : exec, debounce_mode === undefined ? delay - elapsed : delay );
	      }
	    };
	    
	    // Set the guid of `wrapper` function to the same of original callback, so
	    // it can be removed in jQuery 1.4+ .unbind or .die by using the original
	    // callback as a reference.
	    if ( $.guid ) {
	      wrapper.guid = callback.guid = callback.guid || $.guid++;
	    }
	    
	    // Return the wrapper function.
	    return wrapper;
	  };
	  
	  // Method: jQuery.debounce
	  // 
	  // Debounce execution of a function. Debouncing, unlike throttling,
	  // guarantees that a function is only executed a single time, either at the
	  // very beginning of a series of calls, or at the very end. If you want to
	  // simply rate-limit execution of a function, see the <jQuery.throttle>
	  // method.
	  // 
	  // In this visualization, | is a debounced-function call and X is the actual
	  // callback execution:
	  // 
	  // > Debounced with `at_begin` specified as false or unspecified:
	  // > ||||||||||||||||||||||||| (pause) |||||||||||||||||||||||||
	  // >                          X                                 X
	  // > 
	  // > Debounced with `at_begin` specified as true:
	  // > ||||||||||||||||||||||||| (pause) |||||||||||||||||||||||||
	  // > X                                 X
	  // 
	  // Usage:
	  // 
	  // > var debounced = jQuery.debounce( delay, [ at_begin, ] callback );
	  // > 
	  // > jQuery('selector').bind( 'someevent', debounced );
	  // > jQuery('selector').unbind( 'someevent', debounced );
	  // 
	  // This also works in jQuery 1.4+:
	  // 
	  // > jQuery('selector').bind( 'someevent', jQuery.debounce( delay, [ at_begin, ] callback ) );
	  // > jQuery('selector').unbind( 'someevent', callback );
	  // 
	  // Arguments:
	  // 
	  //  delay - (Number) A zero-or-greater delay in milliseconds. For event
	  //    callbacks, values around 100 or 250 (or even higher) are most useful.
	  //  at_begin - (Boolean) Optional, defaults to false. If at_begin is false or
	  //    unspecified, callback will only be executed `delay` milliseconds after
	  //    the last debounced-function call. If at_begin is true, callback will be
	  //    executed only at the first debounced-function call. (After the
	  //    throttled-function has not been called for `delay` milliseconds, the
	  //    internal counter is reset)
	  //  callback - (Function) A function to be executed after delay milliseconds.
	  //    The `this` context and all arguments are passed through, as-is, to
	  //    `callback` when the debounced-function is executed.
	  // 
	  // Returns:
	  // 
	  //  (Function) A new, debounced, function.
	  
	  $.debounce = function( delay, at_begin, callback ) {
	    return callback === undefined
	      ? jq_throttle( delay, at_begin, false )
	      : jq_throttle( delay, callback, at_begin !== false );
	  };
	  
	})(this);


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	$( document ).ready(function() { // wait for document ready
	    // 1 - clone the menu to display on the footer
	    // 2 - wrap menu div with a vertically centering container
	    // 3 - wrap div around menu container for specific control
	    // 4 - show/hid careers or contact form
	    $("#menu-full").clone().prop({ id: "menu-full-footer", name: "menu-full-footer", class: "not-hidden" }).appendTo('#menu-full-contact-careers-container');
	    $( ".menu-elements" ).wrapInner( "<div class='menu-elements-container'></div>");

	    var contact = $("div#contact-container").html();
	    $(contact).appendTo($("div.menu-container"));


	    var hash = $(location).attr('hash');
	    if(hash.toLowerCase().indexOf("show-careers") === 1){
	        $( ".contact" ).addClass( "go-away" );
	    }else{
	        $( ".careers" ).addClass( "go-away" );
	    }
	    if(window.location.pathname == "/"){
	        $('.homepage-screen-four-right-mobile').slick({
	            arrows: false,
	            infinite: true,
	            swipeToSlide: true,
	            centerMode: true,
	        });
	        $('.homepage-videos-mobile').slick({
	            arrows: false,
	            infinite: true,
	            swipeToSlide: true,
	            centerMode: true,
	        });
	        $('.homepage-screen-two-right-bottom-mobile-carousel').slick({
	            arrows: false,
	            infinite: true,
	            swipeToSlide: true,
	            centerMode: true,
	        });


	       
	        $.ajax({
	            type: "GET",
	            url: 'https://www.instagram.com/true_north_inc/?__a=1',
	            success: function(response)
	            {
	                // console.log("Instagram"+response);
	                var insta_posts = response.graphql.user.edge_owner_to_timeline_media.edges;
	                var posts_html = '';
	                for(var i=0;i<2;i++){
	                    var url = insta_posts[i].node.shortcode;
	                    var likes = insta_posts[i].node.edge_liked_by.count;
	                    var comments = insta_posts[i].node.edge_media_to_comment.count;
	                    var thumbnail = insta_posts[i].node.thumbnail_src;
	                   
	                    posts_html += '<div class="homepage-instagram-right"><a href=https://www.instagram.com/p/'+url+' target="_blank"><img src="'+thumbnail+'"></a><div class="homepage-instagram-meta"><span class="fa fa-instagram"></span><div class="homepage-instagram-meta-container"><ul><li><span class="fa fa-heart"></span>'+likes+'</li><!--<li><span class="fa fa-comments"></span>'+comments+'</li>--></ul></div></div></div>';
	                }
	                $(".homepage-instagram-container").html(posts_html);
	            
	            },
	            error: function(){
	               
	                
	            }
	        });
	    }
	    
	    if(window.location.pathname == "/blog/"){
	        $("#menu-page-title").html("<a href='/blog/'>BLOG</a>");
	    }
	     
	     //add class based on pathname
	     if(window.location.pathname == "/contact-careers/"){
	        //console.log("contact page");
	       var compass = document.getElementById("menu-compass-rose");
	       compass.classList.add("compass-rose-spin");
	       
	     }
	   
	      console.log( $("#menu-full-contact-careers-container input.required").length);
	     
	      $("#menu-full-contact-careers-container .submit").on("click", function(){
	        //   console.log("click");
	        
	          var formValidate = true;
	        //   $("#menu-full-contact-careers-container .group .required input[name='interest']:checked")
	          $("#menu-full-contact-careers-container .group .required").each(function(){
	            
	            // var $radiovalue = $("input[name='interest']:checked").val();
	            // if($radiovalue){
	            //     $(this).parent('.group').removeClass("error");
	            //     formValidate = true;
	            //     console.log("radio = " +formValidate);
	            // }else{
	            //     formValidate = false;
	            //     console.log("radio = " +formValidate);
	            // }

	            if ($.trim($(this).val()).length == 0){
	                $(this).parent().addClass("error");
	                formValidate = false;
	                //console.log("form field = " +formValidate);
	               
	            }
	            else{
	                formValidate = true;
	                $(this).parent().removeClass("error");
	                //console.log("form field = " +formValidate);
	            }
	        });

	        if( formValidate){
	            //console.log("100% complete");
	            var form =  $("#menu-full-contact-careers-container form");
	            var name =  document.querySelector('#menu-full-contact-careers-container input[name="name"]').value;
	            var phone =  document.querySelector('#menu-full-contact-careers-container input[name="phone"]').value;
	            var email =  document.querySelector('#menu-full-contact-careers-container input[name="email"]').value;
	            var message =  document.querySelector('#menu-full-contact-careers-container #message').value;
	            var interest = document.querySelector('#menu-full-contact-careers-container input[name="interest"]:checked').value;
	            var url = '/wp-content/themes/truenorth2019/contact-submit.php?name='+name+'&phone='+phone+'&email='+email+'&message='+message+'&interest='+interest;
	            //console.log(url);
	            $.ajax({
	                type: "POST",
	                url: url,
	                data: form.serialize(), // serializes the form's elements.
	                success: function(data)
	                {
	                    // alert(data); // show response from the php script.
	                    //console.log("formpost");
	                    $("#menu-full-contact-careers-container .message").addClass("show");
	                    $("#menu-full-contact-careers-container #formWrapper").hide();
	                    $("#menu-full-contact-careers-container .message .success").removeClass("hidden");
	                    $("#menu-full-contact-careers-container .message .error").addClass("hide");
	                },
	                error: function(){
	                    $("#menu-full-contact-careers-container .message").addClass("show");
	                    $("#menu-full-contact-careers-container .message .success").addClass("hide");
	                    $("#menu-full-contact-careers-container .message .error").removeClass("hidden");
	                    
	                }
	            });
	        }else{
	            //console.log("not complete");
	            
	        }

	      })

	      

	    //   $("#contactform").submit(function(event) {
	    // console.log("yy");
	    //         event.preventDefault(); // avoid to execute the actual submit of the form.
	        
	    //         var form = $(this);
	    //         var url = '/contact-submission/';
	    
	           
	    
	    //         if (!isFormValid) alert("Please fill in all the required fields (indicated by *)");
	    //         $.ajax({
	    //             type: "POST",
	    //             url: url,
	    //             data: form.serialize(), // serializes the form's elements.
	    //             success: function(data)
	    //             {
	    //                 alert(data); // show response from the php script.
	    //             }
	    //          });
	    
	    //         return isFormValid;
	        
	            
	        
	        
	    //     });

	});


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	$(function () { 
	    $("#hamburger-menu").on('click', function() {
	        menutoggle(this) 
	    })
	    $("#slim-hamburger-menu").on('click', function() {
	        menutoggle(this) 
	    })
	    function menutoggle(x) {
	        x.classList.toggle("change");
	    }

	    $(".menu-hamburger-container").on('click', function() {
	        $('#menu-compass-rose').removeClass("compass-rose-spin");
	        if($("#menu-full").hasClass("hidden")){
	            $('#menu-full').removeClass('hidden');
	            $('#menu-compass-rose').addClass("compass-rose-spin")
	            $('#menu-full').addClass('not-hidden');
	            $('#menu-page-title').addClass('hidden');
	        }else{
	            $('#menu-full').addClass('hidden');
	            $('#menu-full').removeClass('not-hidden');
	            $('#menu-compass-rose').removeClass("compass-rose-spin")
	            $('#menu-page-title').removeClass('hidden');
	        }
	    });
	    // clone the menu to display on the footer///
	    $("#menu-full").clone().prop({ id: "menu-full-footer", name: "menu-full-footer", class: "menu-full-general not-hidden" }).appendTo('#menu-full-footer-container');

	    function getOffset(el) {
	          const rect = el.getBoundingClientRect();
	          return {
	            left: rect.left + window.scrollX,
	            top: rect.top + window.scrollY
	          };
	        }

	        var pageId = document.getElementsByClassName("container--canvas")[0].id;

	        if(window.scrollY === 0 ){
	            document.getElementById("fullnav").classList.remove("hide");
	            document.getElementById("slimnav").classList.add("hide");
	        }else{
	            document.getElementById("fullnav").classList.add("hide");
	            document.getElementById("slimnav").classList.remove("hide");
	            
	        }

	       

	        window.addEventListener('scroll', function(e) {
	            //console.log("scrolling");
	             switch(pageId) {
	                    
	             default:
	             // code block
	              if(window.scrollY > 100 ){
	                    document.getElementById("fullnav").classList.add("hide");
	                    document.getElementById("slimnav").classList.remove("hide");
	                }else{
	                    document.getElementById("fullnav").classList.remove("hide");
	                    document.getElementById("slimnav").classList.add("hide");
	                }
	            }
	            
	        });
	   
	});

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	$(function () { 
	// Implement Trigger points for any HTML Section ON SCROLL BEGIN//
	    // init controller
	    var controller = new ScrollMagic.Controller();
	    // build scene
	    var scene = new ScrollMagic.Scene({
	            triggerElement: "#s1",
	            offset: 0,
	            triggerHook: .04,
	        })
	        // .setTween("nav", 0.25, {backgroundColor:"rgba(0, 128, 0,0.5)"}) // trigger a TweenMax.to tween
	        // .addIndicators({name: ":1"}) // add indicators (requires plugin)
	        .addTo(controller);
	   if(window.location.pathname == "/"){
	    var scene2 = new ScrollMagic.Scene({
	            triggerElement: "#s2",
	            offset: 0,
	            triggerHook: .04,
	        })
	        // .setTween("nav", 0.25, {backgroundColor: "rgba(0, 0, 255, 0.5)"}) // trigger a TweenMax.to tween
	        // .addIndicators({name: ":2"}) // add indicators (requires plugin)
	        .addTo(controller);

	    var scene3 = new ScrollMagic.Scene({
	            triggerElement: "#s3",
	            offset: 0,
	            triggerHook: .04,
	        })
	        // .setTween("nav", 0.25, {backgroundColor: "rgba(255, 0, 0, 0.5)"}) // trigger a TweenMax.to tween
	        // .addIndicators({name: ":3"}) // add indicators (requires plugin)
	        .addTo(controller);

	    var menuFooter = new ScrollMagic.Scene({
	            triggerElement: "#menu-full-footer-container",
	            offset: 0,
	            triggerHook: .04,
	            })
	            .setClassToggle("#menu-compass-rose", "compass-rose-spin")
	            // .setTween("nav", 0.25, {backgroundColor: "rgba(0, 0, 255, 0.5)"}) // trigger a TweenMax.to tween
	            // .addIndicators({name: ":4"}) // add indicators (requires plugin)
	            .addTo(controller);
	     // Implement Trigger points for any HTML Section ON SCROLL END//   
	    }  
	});

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	$(function () { 
	    if(window.location.pathname == "/work/"){
	         var dataLength = [0];
	        var increment_num = 0;
	        var a, b, c;
	        var cycle;
	        var timer = 2000;
	        var slideWidth = $(".work-left").width();
	        var slideWidth2 =  $("#work-right-bottom").width();
	        var slideHeight = $("#work-right-top").outerHeight();
	        var otherIteration = [];
	        function WorkPosts(){
	            $.ajax({
	                type: 'GET',
	                url: "/wp-json/wp/v2/work?_embed&per_page=20",
	                    
	                success: function(data) {
	                    var obj = JSON.stringify(data);
	                    var work_data = jQuery.parseJSON(obj);
	                    dataLength.unshift(work_data.length);
	                    
	                    // console.log(work_data);
	                    function slideContent(){
	                        var left_block = document.getElementById("work-content-left");
	                    
	                        left_block.innerHTML ="";
	                        var leftcss = -$(".work-left").width();

	                        left_block.innerHTML +=  '<div id="slide'+ (dataLength[0]-1)+'" class="slide horizontal-slide last-slide"   style="margin-left:-'+ $(".work-left").width()+'px"><a href="'+work_data[dataLength[0]-1].link +'"><img class="image img-parallax" style="background-image:url('+work_data[dataLength[0]-1]._embedded['wp:featuredmedia']['0'].source_url+'"></a><div class="work-meta-container"><p><a class="cat" href="'+work_data[dataLength[0]-1].link +'">'+work_data[dataLength[0]-1]._embedded["wp:term"][0][0]['name']+'</a></p><h2 class="title">'+work_data[dataLength[0]-1].title.rendered+'</h2></div></div>';

	                        for (var i = 0; i <  dataLength[0]-1; i++){
	                            leftcss = leftcss + $(".work-left").width();
	                            
	                            left_block.innerHTML +=  '<div id="slide'+(i)+'" class="slide horizontal-slide"  style="margin-left:'+ leftcss+'px"><a href="'+work_data[i].link +'"><img class="image img-parallax" src="'+work_data[i]._embedded['wp:featuredmedia']['0'].source_url+'"></a><div class="work-meta-container"><p><a class="cat" href="'+work_data[i].link +'">'+work_data[i]._embedded["wp:term"][0][0]['name']+'</a></p><h2 class="title">'+work_data[i].title.rendered+'</h2></div></div>';
	                        }
	                      
	            
	                        var right_top_block = document.getElementById("work-right-top");
	                        // right_block.innerHTML ="";
	                        var right_topcss = '-'+($("#work-right-top").outerHeight());

	                        right_top_block.innerHTML +=  '<div id="right-top-slide0"  class="slide first-slide vertical-slide"   style="top:-'+$("#work-right-top").outerHeight()+'px"><div class="work-meta-container"><p><a class="cat" href="'+work_data[0].link +'">'+work_data[0]._embedded["wp:term"][0][0]['name']+'</a></p><h2 class="title">'+work_data[0].title.rendered+'</h2></div><a href="'+work_data[0].link +'"><img class="image img-parallax" src="'+work_data[0]._embedded['wp:featuredmedia']['0'].source_url+'"></a></div>';

	                        for (var j = 1; j <  dataLength[0]; j++){
	                            right_topcss = parseInt(right_topcss) + $("#work-right-top").outerHeight();
	                            
	                            right_top_block.innerHTML +=  '<div id="right-top-slide'+(j)+'" class="slide vertical-slide" style="top:'+ right_topcss+'px"><a href="'+work_data[j].link +'"><img class="image img-parallax" src="'+work_data[j]._embedded['wp:featuredmedia']['0'].source_url+'"></a><div class="work-meta-container"><p><a class="cat" href="'+work_data[j].link +'">'+work_data[j]._embedded["wp:term"][0][0]['name']+'</a></p><h2 class="title">'+work_data[j].title.rendered+'</h2></div></div>';
	                        }

	                        b = $('#work-right-top').html();
	                    
	                        var right_bottom_block = document.getElementById("work-right-bottom");
	                        // right_block.innerHTML ="";
	                        var right_bottomcss = -($("#work-right-bottom").width());

	                     
	                         right_bottom_block.innerHTML +=  '<div id="right-bottom-slide1" class="slide second-slide horizontal-slide2"  style="margin-left:-'+ $("#work-right-bottom").width() +'px"><a href="'+work_data[1].link +'"><img class="image img-parallax" src="'+work_data[1]._embedded['wp:featuredmedia']['0'].source_url+'"></a><div class="work-meta-container"><p><a class="cat" href="'+work_data[1].link +'">'+work_data[1]._embedded["wp:term"][0][0]['name']+'</a></p><h2 class="title">'+work_data[1].title.rendered+'</h2></div></div>';


	                        for (var k = 2; k < dataLength[0]; k++){
	                            right_bottomcss = right_bottomcss + $("#work-right-bottom").width();
	                            
	                            right_bottom_block.innerHTML +=  '<div  id="right-bottom-slide'+(k)+'" class="slide  horizontal-slide2" style="margin-left:'+ right_bottomcss+'px"><a href="'+work_data[k].link +'"><img class="image img-parallax" src="'+work_data[k]._embedded['wp:featuredmedia']['0'].source_url+'"></a><div class="work-meta-container"><p><a class="cat" href="'+work_data[k].link +'">'+work_data[k]._embedded["wp:term"][0][0]['name']+'</a></p><h2 class="title">'+work_data[k].title.rendered+'</h2></div></div>';
	                        }

	                        right_bottom_block.innerHTML +=  '<div id="right-bottom-slide0" class="slide initial_first-slide  horizontal-slide2"   style="margin-left:'+ $("#work-right-bottom").width()*(dataLength[0]-2)+'px"><a href="'+work_data[0].link +'"><img class="image img-parallax" src="'+work_data[0]._embedded['wp:featuredmedia']['0'].source_url+'"></a><div class="work-meta-container"><p><a class="cat" href="'+work_data[0].link +'">'+work_data[0]._embedded["wp:term"][0][0]['name']+'</a></p><h2 class="title">'+work_data[0].title.rendered+'</h2></div></div>';
	                      
	                    }
	                    slideContent();
	                }
	            });
	       
	           
	            $(window).on('resize', function(){
	                slideWidth = $(".work-left").width();
	                slideWidth2 =  $("#work-right-bottom").width();
	                slideHeight = $("#work-right-top").outerHeight();
	                //console.log("resizing...");
	                //console.log("slideWidth:.."+slideWidth)
	            });
	            var e = jQuery.Event("keydown", { keyCode: 39 });

	            function loop(){
	                cycle = setInterval(function(counter){
	                 
	                    clearInterval(cycle);
	                    jQuery("body").trigger( e );

	                    loop();
	                    
	                    
	                    // trigger an artificial keydown event with keyCode 64
	                    //console.log(increment_num);
	                }, 700000);
	            }
	            loop();
	        }

	        //init Work Posts
	        WorkPosts();

	       function forwardCarousel(){
	        keyCounter++;
	        //skip iteration number 0 to 1
	        if(keyCounter == dataLength[0] ){
	             keyCounter = 0;
	            //console.log(keyCounter);
	        }

	        //LEFT SCREEN CAROUSEL ANIMATION
	           $( "#work-content-left .slide" ).animate({

	              marginLeft: '-='+ slideWidth+'px'

	            }, timer, function() {

	              // Animation complete.

	              //console.log("Data Length: "+ dataLength[0])
	              //console.log("KeyCounter: "+keyCounter)
	         
	                
	                 //keep moving first element to end
	                
	                 if(keyCounter == 0){
	                    $('#slide'+((keyCounter)+(dataLength[0])-1)).prev().appendTo("#work-content-left").css({"margin-left":(slideWidth*(dataLength[0]-2))+'px'});
	                    // keyCounter = 0;
	                 }else{
	                    $('#slide'+((keyCounter)%(dataLength[0])-1)).prev().appendTo("#work-content-left").css({"margin-left":(slideWidth*(dataLength[0]-2))+'px'});
	                 }
	              

	                // var leftcss = -($(".work-left").width()*2);
	                
	                //update each slide positioning after appending first slide
	                // $(".horizontal-slide").each(function(){
	                    
	                //     leftcss = leftcss + $(".work-left").width();
	                //    $(this).css({"margin-left":leftcss+'px'})

	                // });

	                //console.log("append to end now");
	                //console.log("Apppend Counter: "+ keyCounter);
	            });


	            //RIGHT SCREEN TOP CAROUSEL ANIMATION
	            $( "#work-right-top .slide" ).animate({
	              top: '-='+ slideHeight + 'px'
	            }, timer, function() {
	             // Animation complete.
	             //keep moving first element to end
	        
	             var righttopcss = -($("#work-right-top").outerHeight()*3);
	            
	            // //update each slide positioning after appending first slide
	            // $(".vertical-slide").each(function(){   
	            //     righttopcss = righttopcss +$("#work-right-top").outerHeight();
	            //     $(this).css({"top":righttopcss+'px'})
	            // });
	            //  $('#right-top-slide'+dataLength[0]).appendTo("#work-right-top");
	          

	            if(keyCounter == 0){
	                $('#right-top-slide'+((keyCounter)+(dataLength[0])-1)).prev().appendTo("#work-right-top").css({"top":(slideHeight*(dataLength[0]-3))+'px'});
	                keyCounter = 0;
	             }else{
	                $('#right-top-slide'+((keyCounter)%(dataLength[0])-1)).prev().appendTo("#work-right-top").css({"top":(slideHeight*(dataLength[0]-3))+'px'});
	             }
	           
	            });

	             //RIGHT SCREEN BOTTOM CAROUSEL ANIMATION
	            $( "#work-right-bottom .slide" ).animate({
	                marginLeft: '-='+ slideWidth2 + 'px'
	            }, timer, function() {
	                // Animation complete.
	                 //keep moving first element to end
	                 $('#right-bottom-slide'+keyCounter).appendTo("#work-right-bottom").css({"margin-left":(slideWidth2*(dataLength[0]-2))+'px'});

	                //  var leftcss = -($("#work-right-bottom").width()*2);
	                //  $(".horizontal-slide2").each(function(){
	                    
	                //     leftcss = leftcss + $("#work-right-bottom").width();
	                //    $(this).css({"margin-left":leftcss+'px'})
	                // });
	            });
	        }



	        function backwardCarousel(){
	            keyCounter--;

	            //console.log("Data Length: "+ dataLength[0])
	            //console.log("KeyCounter: "+keyCounter)
	               
	               
	            $( "#work-content-left .slide" ).animate({
	                marginLeft: '+='+ slideWidth+'px'
	            }, timer, function() {
	                // Animation complete.
	                
	                //keep moving last element to front
	                if(keyCounter == -1){
	                    keyCounter = dataLength[0]-1;
	                    $('#right-bottom-slide0').prependTo("#work-right-bottom").css({"margin-left":"-"+(slideWidth2)+'px'});

	                    // alert(keyCounter);
	                }



	                if(keyCounter > 0){
	                    $('#slide'+(keyCounter-1)).prependTo("#work-content-left").css({"margin-left":"-"+(slideWidth)+'px'});

	                }

	                if(keyCounter == 0){
	                    $('#slide'+(dataLength[0]-1)).prependTo("#work-content-left").css({"margin-left":"-"+(slideWidth)+'px'});

	                }



	               

	               
	                // if(keyCounter => dataLength[0]){
	                //     keyCounter = 0;
	                // }

	                // if(keyCounter == -1){
	                //     // $('#slide5').prependTo("#work-content-left").css({"margin-left":"0px"});
	                //     // $('#right-bottom-slide0').prependTo("#work-right-bottom").css({"margin-left":"0px"});

	                //     keyCounter = dataLength[0]-1;
	                    
	                  
	                // }else if(keyCounter == 0){
	                //     keyCounter = dataLength[0];
	                //     $('#slide'+(keyCounter)).prependTo("#work-content-left").css({"margin-left":"-"+(slideWidth)+'px'});


	                // }else{
	                //     $('#slide'+(keyCounter-1)).prependTo("#work-content-left").css({"margin-left":"-"+(slideWidth)+'px'});

	                // }

	                // if(keyCounter >= (keyCounter/2) && keyCounter%3 == 0){
	                //     alert("yo");
	                //     $('#slide'+(keyCounter)).prependTo("#work-content-left").css({"margin-left":"-"+(slideWidth)+'px'});

	                // }


	                // var leftcss = +($(".work-left").width());
	                // $('#slide'+(keyCounter)).prependTo("#work-right-top").css({"margin-left":"-"+(slideWidth)+'px'});
	            
	                //update each slide positioning after prepending first slide
	                // $(".horizontal-slide").each(function(){
	                //     // leftcss = leftcss - $(".work-left").width();
	                //     $(this).css({"margin-left":Math.abs($(this).css("margin-left") - $(".work-left").width())+'px'})
	                // });
	            });

	                $( "#work-right-top .slide" ).animate({
	                    top: '+='+ slideHeight + 'px'
	                }, timer, function() {
	                    // Animation complete.
	                     //keep moving first element to end
	                
	                     $('#right-top-slide'+(keyCounter)).prependTo("#work-right-top").css({"top" : -$("#work-right-top").outerHeight()+'px'});
	                   
	                });

	                $( "#work-right-bottom .slide" ).animate({
	                    marginLeft: '+='+ slideWidth2 + 'px',
	                }, timer, function() {
	                    // Animation complete.


	                    if(keyCounter < dataLength[0]-1){
	                        $('#right-bottom-slide'+(keyCounter+1)).prependTo("#work-right-bottom").css({"margin-left":"-"+(slideWidth2)+'px'});
	    
	                    }
	    
	                    // if(keyCounter == 0){
	                    //     ('#right-bottom-slide'+(dataLength[0]-1)).prependTo("#work-content-left").css({"margin-left":"-"+(slideWidth)+'px'});
	    
	                    // }

	                
	                  

	                    
	                });
	            //// ANIMATION END ////
	            
	        }
	        
	        //console.log(increment_num);
	        var keyCounter = increment_num; 
	    

	        //KEYPRESS LEFT/RIGHT BEGIN//
	        $("body").bind('keydown', $.debounce( 550, true, function(e) {
	            
	            clearInterval(cycle);
	           //console.log("keypress");
	            
	            if(e.keyCode == 37) { // left
	                
	                backwardCarousel();
	        
	            }else if(e.keyCode == 39) { // right
	                forwardCarousel();
	            }
	        }));



	        //MOUSE SCROLL BEGIN//
	        $('#work').bind('mousewheel', $.debounce( 550, true, function(e){
	            //console.log("scrolling");
	            clearInterval(cycle);
	            if(e.originalEvent.wheelDelta < 0) {//scroll down
	                //console.log("scroll down");
	                forwardCarousel();
	               

	            }else{//scroll up
	                backwardCarousel();
	            }
	        }));
	       

	    }
	})

/***/ })
/******/ ]);